module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "game"
  }, [_c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.graph), function(row) {
    return _c('li', [_c('ul', {
      staticClass: "col"
    }, _vm._l((row), function(col) {
      return _c('li', {
        staticClass: "rect",
        class: {
          'filled': col
        }
      }, [_c('div')])
    }))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "loop"
  }, [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": _vm.pause
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("P")]), _vm._v(" "), _c('span', [_vm._v("pause")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.reset()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "drop",
    on: {
      "click": function($event) {
        _vm.tetris.drop()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("D")]), _vm._v(" "), _c('span', [_vm._v("Drop(space)")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.rotate()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("O")]), _vm._v(" "), _c('span', [_vm._v("Rotate(up)")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-space-around"
  }, [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.left()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("L")]), _vm._v(" "), _c('span', [_vm._v("Left(left)")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.right()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', [_vm._v("Right(right)")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.down()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("D")]), _vm._v(" "), _c('span', [_vm._v("Down(down)")])])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "//github.com/wasd-org/wasd-tetris",
      "target": "_blank"
    }
  }, [_vm._v("wasd-tetris")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b4c016c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 13
// module chunks = 1